import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { useHistory, useLocation } from 'react-router-dom'
import styles from './index.module.less'
import ID from './tabs/ID'
import Phone from './tabs/Phone'
import WorkWechat from './tabs/WorkWechat'
import ResetPassword from './resetPassword'
import Tabs from './Tabs'

export default function Index() {
  const history = useHistory()
  const { pathname } = useLocation()

  const Login = () => (
    <>
      <div className={styles.logo}></div>
      <Route path={['/mobile/id', '/mobile/phone']}>
        <Tabs />
        <Route path="/mobile/id">
          <ID />
        </Route>
        <Route path="/mobile/phone">
          <Phone />
        </Route>
      </Route>
      <Route exact path="/mobile/work-wechat">
        <WorkWechat></WorkWechat>
      </Route>
    </>
  )

  return (
    <div className={styles.wrapper}>
      {['/mobile/work-wechat', '/mobile/reset-password'].includes(pathname) && (
        <div className={styles.back} onClick={() => history.goBack()} />
      )}
      <Switch>
        <Route path={['/mobile/id', '/mobile/phone', '/mobile/work-wechat']}>
          <Login />
        </Route>
        <Route path="/mobile/reset-password">
          <ResetPassword />
        </Route>
        <Redirect to="/mobile/id"></Redirect>
      </Switch>
    </div>
  )
}
